import {
  BillingStatus1 as BillingStatus, // TODO(Jenky): must check the docs, fix this
  BillingStatus1,
  SubscriptionPlan,
  SubscriptionStatus,
} from '@innovationdepartment/proxima-sdk-axios';

export type BillingContact = {
  contactId: string;
  email: string;
  createdAt: string;
  brandId: string;
};

export type CreateBillingContactSchema = {
  email: BillingContact['email'];
};

export type CreateResponseBillingContactSchema = {
  contactId: BillingContact['contactId'];
};

export type GetBillingContactsSchema = BillingContact[];

export type BillingViewProps = {
  contacts: BillingContact[];
  onContactsChange: (tags: string[]) => void;
  loading: boolean;
};

export enum BillingFrequency {
  Monthly = 'monthly',
  Yearly = 'yearly',
}

export type PlanDescription = {
  monthly: string;
  yearly: string;
  freeTrial: React.ReactNode;
  noPlan: React.ReactNode;
};

export const PricingTiers = {
  MonthByMonth: 119,
  Annual: 99 * 12,
} as const;

export enum Plan {
  Trial = 'TRIAL',
  MonthByMonth = 'EVERY_30_DAYS',
  Annual = 'ANNUAL',
}

export type BillingPlanDefinitions = {
  isLocked: boolean;
  isPaymentFailed: boolean;
  isPastTrial: boolean;
  isCancelled: boolean;
  isTrial: boolean;
  isMonthly: boolean;
  isYearly: boolean;
  isPendingConfirmation: boolean;
  isPendingCancellation: boolean;
  planName: string;
  trialDaysLeft: number;
  trialEnd: string;
  plan: SubscriptionPlan | undefined;
  remainingDays?: number;
  isManaged: boolean;
  planIsPending: boolean;
  isAccountStillActive: boolean;
  hasPlanAndStillOnTrial: boolean;
};

/* defined names for the available Shopify billing subscriptions */
export const PlanNames = {
  [Plan.MonthByMonth]: 'Proxima - Monthly',
  [Plan.Annual]: 'Proxima - Annual',
  [Plan.Trial]: 'Proxima - Trial',
  PlanCancelled: 'Proxima - Cancelled',
} as const;

export type BillingPlanTypeSubscription = {
  undertext?: string;
  billingPlanStatus: BillingPlanDefinitions;
  handleButtonClick: (choosePlan: boolean) => void;
};

export type BillingHistory = {
  createdAt: string;
  newPlan?: Plan;
  subscriptionId?: string;
};

export type BillingPlanSubscription = {
  brandId: string;
  trialEnd: string;
  subscriptionId: string;
  plan: SubscriptionPlan | undefined;
  status: BillingStatus1;
  history?: BillingHistory[];
  billApprovalDate?: string;
};

export type SubscriptionType = {
  trialEnd: string;
  status: BillingStatus;
  paymentFailed: boolean;
  plan?: SubscriptionPlan;
  billApprovalDate?: string;
  subscriptionStatus?: SubscriptionStatus;
};
